import * as LoginTypes from 'src/actions/authentication/login/Types';
import * as RegisterTypes from 'src/actions/authentication/register/Types';
import * as GetUserTypes from 'src/actions/user/get/Types';
import * as ProfileMetricsTypes from 'src/actions/profile-metrics/get/Types';
import { GetUserAction, GetUserSuccess } from 'src/actions/user/get/GetUser.actions';
import User from 'src/entities/User';
import { LoginAction } from 'src/actions/authentication/login/Login.actions';
import { RegisterAction } from 'src/actions/authentication/register/Register.actions';
import Person from 'src/entities/Person';
import * as SetActiveProfileTypes from 'src/actions/active-profile/set/Types';
import { SetActiveProfile } from 'src/actions/active-profile/set/SetActiveProfile.actions';
import * as ChangeDefaultProfileTypes from 'src/actions/default-profile/change/Types';
import { ChangeDefaultProfileAction } from 'src/actions/default-profile/change/ChangeDefaultProfile.actions';
import { GetProfileMetricsAction } from 'src/actions/profile-metrics/get/GetProfileMetrics.actions';
import ProfileMetrics from 'src/value-objects/ProfileMetrics';

export interface GetUserState {
  user?: User;
  loading: boolean;
  error: boolean;
  errorMessage: {};
  activeProfile?: Person;
  defaultProfile?: Person;
  profileMetrics?: ProfileMetrics;
}

const initialState: GetUserState = {
  loading: false,
  error: false,
  errorMessage: {},
};

export function GetUserReducer(
  state: GetUserState = initialState,
  action: GetUserAction | LoginAction | RegisterAction | SetActiveProfile | 
    ChangeDefaultProfileAction | GetProfileMetricsAction
): GetUserState {
  switch (action.type) {
    case RegisterTypes.REGISTER_SUCCESS:
      return { ...state, user: undefined };
    case LoginTypes.LOGIN_SUCCESS:
      return { 
        ...state, user: undefined, defaultProfile: undefined, activeProfile: undefined, profileMetrics: undefined
      };
    case GetUserTypes.GET_USER_ATTEMPT:
      return { ...state, user: undefined, loading: true, error: false };
    case GetUserTypes.GET_USER_SUCCESS:
      const user: User = (action as GetUserSuccess).payload;
      const activeProfile: Person = state.activeProfile ? state.activeProfile : user.defaultProfile;
      const defaultProfile: Person = user.defaultProfile;
      return {
        ...state, user: user, loading: false, error: false,
        activeProfile: activeProfile, defaultProfile: defaultProfile, profileMetrics: undefined
      };
    case GetUserTypes.GET_USER_FAILURE:
      return { ...state, user: undefined, loading: false, error: true, errorMessage: action.payload };
    case SetActiveProfileTypes.SET_ACTIVE_PROFILE:
      return { ...state, activeProfile: action.payload };
    case ChangeDefaultProfileTypes.CHANGE_DEFAULT_PROFILE_ATTEMPT:
      return { ...state };
    case ChangeDefaultProfileTypes.CHANGE_DEFAULT_PROFILE_SUCCESS:
      return { ...state, defaultProfile: undefined, activeProfile: undefined, profileMetrics: undefined };
    case ProfileMetricsTypes.GET_PROFILE_METRICS_SUCCESS:
      return { ...state, profileMetrics: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user/GetUserReducer.tsx